import BilletCreation from '../pages/BilletCreation';

export const billetCreationRoutePage = {
  component: <BilletCreation />,
  route: '/emissao-de-boleto',
};
